import axios from 'axios';
import { apiClient } from './apiClient';
import { API } from './apiUrls';

export async function retrieveAccessTokenFromBackend(): Promise<string | null> {
    // Get CSRF cookie from backend
    await axios.get(API.auth.csrf, {
        withCredentials: true,
    });

    // Read CSRF token from cookie
    const cookieFields = document.cookie.split(';');
    const csrftoken = cookieFields.find((field) =>
        field.trim().startsWith('csrftoken='),
    );
    const csrftokenValue = csrftoken ? csrftoken.split('=')[1] : null;

    // Request access token from backend
    const response = await axios.post<{ access?: string }>(
        API.auth.token,
        null,
        csrftokenValue
            ? {
                  withCredentials: true,
                  headers: { 'X-CSRFToken': csrftokenValue },
              }
            : { withCredentials: true },
    );

    const data = response.data as { access?: string } | undefined;
    return data?.access ?? null;
}

export async function getCurrentUsername(): Promise<string | null> {
    const token = await retrieveAccessTokenFromBackend();
    if (!token) return null;
    try {
        const parts = token.split('.');
        if (parts.length !== 3 || !parts[1]) return null;
        const payloadJson = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
        const payload = JSON.parse(payloadJson);
        // Common JWT fields: 'username', 'user', 'sub'
        return payload.username || payload.user || payload.sub || null;
    } catch {
        return null;
    }
}

export type UserProfile = {
    id: number;
    user: number;
    background?: string;
    focus_areas?: string;
    industry_knowledge?: number;
    desire?: string;
    anxieties?: string;
    username?: string; // if backend adds it
};

export async function fetchCurrentUserProfile(): Promise<UserProfile | null> {
    try {
        const response = await apiClient.get<UserProfile>('/api/profile/');
        return response.data ?? null;
    } catch (err) {
        console.warn('[security] Failed to fetch current user profile', err);
        return null;
    }
}
